module.exports = __webpack_public_path__ + "static/media/Flik_5__Gavofonder.208b31e0.pdf";